import React from "react";
import AboutboxImg from '../../assets/about-image.webp';

const AboutUs = () => {

    return (<>
       <section className="about_section-2">
            <div className="container">
                <div className="row justify-content-around align-items-center">
                     <div className="col-lg-6">
                        <div className="about_img_box">
                            <img src={AboutboxImg} className='img-fluid' alt='Stuck-in-an-emergency' loading='lazy'/>
                        </div>
                    </div>

                    <div className="col-lg-5 about-col-text text-left">
                        <h3>Find the Right Towing Service Near You Instantly</h3>
                        {/*<h4>Stay Updated And Ready For Any Emergency With Truck Repair Services As Your Companion.</h4> */}
                        <p>When your vehicle breaks down on the road, all you want at that moment is
                            for everything to return to normal. In such unpredictable situations, the
                            first hope is to get on the road as soon as possible. You don't have the
                            time nor the energy to compare towing firms or study customer reviews to
                            choose which one would give you the greatest service. That's when Towing
                            411 comes to your help. </p>

                        <div className="about_feature_list">
                             <ul>
                                <li>Fast response time</li>
                                <li>24/7 availability</li>
                                <li>Available all across the United States</li>
                             </ul>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="about_section-1">
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="section-title col-md-12 mb-lg-4 mb-2 pb-3">
                        <h2 className="text-white">Expert Vehicle Towing and Recovery Solutions</h2>
                        <p className="text-white">We can help you find a safe and secure towing service to handle your vehicle.</p>
                    </div>

                    <div className="col-md-12">
                        <div className="about_service_list">
                            <ul>
                               <li>Car Towing <span>Reliable. Fast. Affordable.</span></li>
                                <li>Emergency Towing <span>Quick. Safe. Trusted.</span></li>
                                <li>Flatbed Towing <span>Expert vehicle retrieval.</span></li>
                                <li>Truck Towing <span>Trusted Vehicle Transport</span></li>
                                <li>Heavy Equipment Towing <span>Business vehicle assistance.</span></li>
                                <li>Boat Towing <span>Gentle Boat Handling</span></li>
                                <li>RV Towing <span>Safe and secure vehicle relocation.</span></li>
                                <li>Motorcycle Towing <span>Specialized bike transport.</span></li>
                                <li>Long Distance Towing <span>Reliable transport afar.</span></li>
                                <li>Roadside Assistance <span>Quick aid for common issues.</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </>
    );
};

export default AboutUs;